module.exports = __webpack_public_path__ + "static/media/pop-bg.4299ec27.svg";